import { Button, ButtonProps, SxProps, Theme } from '@mui/material'
import { forwardRef } from 'react';

interface FlowentiButtonProps extends ButtonProps {
    title?: string;
    component?: any;
    to?: string
}

const getPaletteColor = (theme: Theme, color: ButtonProps["color"] = "secondary") => {
    if (!color || color === "inherit") {
        return theme.palette.secondary;
    }
    return theme.palette[color];
};

const FlowentiButton = forwardRef<HTMLButtonElement, FlowentiButtonProps>(
    ({ title, onClick, variant, color = "secondary", sx, children, component, to, ...props }: FlowentiButtonProps, ref) => {
        const buttonSx: SxProps<Theme> = (theme) => {
            const paletteColor = getPaletteColor(theme, color);
            return {
                border:
                    variant === "text"
                        ? "none"
                        : `1px solid ${theme.palette.primary.main}`,
                fontWeight: "bold",
                borderRadius: 5,
                boxShadow: "none",
                px: 3,
                py: 2,
                ...(theme.palette.mode === "dark" && {
                    ...(variant === "outlined" && {
                        color: theme.palette.primary.main,
                        "&:hover": {
                            borderColor: theme.palette.primary.light,
                            backgroundColor: `${theme.palette.primary.main}1f`,
                        },
                    }),
                    ...(variant === "contained" && {
                        color: theme.palette.getContrastText(paletteColor.main),
                        "&:hover": {
                            boxShadow: "none",
                        },
                    }),
                    ...(variant === "text" && {
                        color: paletteColor.main,
                        "&:hover": {
                            backgroundColor: `${paletteColor.main}1f`,
                        },
                    }),
                }),
            };
        };

        return (
            <Button
                to={to}
                onClick={onClick}
                variant={variant as any}
                component={component}
                color={color}
                sx={sx ? [buttonSx, ...(Array.isArray(sx) ? sx : [sx])] : buttonSx}
                {...props}
            >
                {title || children}
            </Button>
        )
    }
)

export default FlowentiButton
